import { FC } from 'react';

import { useApp } from '@hooks/AppHooks';
import { useSparkplugAccount } from '@hooks/SparkplugAccountsHooks/SparkplugAccountsHooks';

import Intercom from '@helpers/Intercom';

/**
 * Displays a banner at the top of the page when the current account
 * has an 'onboarding' status, informing admins that some features are
 * temporarily restricted. Hidden for employee users.
 */
const OnboardingBanner: FC = () => {
    const { isAdminApp } = useApp();
    const { account } = useSparkplugAccount();

    if (!isAdminApp || account?.status !== 'onboarding') {
        return null;
    }

    return (
        <div className="w-full py-3 px-4 text-center text-sm leading-snug z-10 bg-cerulean-0 text-black border-b border-cerulean-100">
            <div className="flex items-center justify-center gap-1.5">
                <span className="shrink-0">👋</span>
                <span>
                    <strong>Onboarding in progress</strong> &mdash; some features are temporarily
                    restricted until onboarding is complete. Questions?{' '}
                    <button
                        type="button"
                        onClick={() => Intercom.open()}
                        className="font-semibold bg-transparent border-none text-cerulean-600 cursor-pointer p-0 hover:underline"
                    >
                        Contact Support &rarr;
                    </button>
                </span>
            </div>
        </div>
    );
};

export default OnboardingBanner;
